// import {
//     Box,
//     Button,
//     FormControl,
//     FormLabel,
//     Input,
//     Select,
//     Textarea,
//     VStack,
//     Heading,
//     Tag,
//     Wrap,
//     WrapItem,
//   } from '@chakra-ui/react';
//   import { useState } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import { saveLead } from '../hooks/leads';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css'; // Prebuilt styles
// import { EmployeeDropdown } from '../components/EmployeeDropDown';
// import CompanySelect from '../components/CompanySelect';
// import { stringify } from 'querystring';

//   const AddNewCustomerPage = () => {
//     const {orgId} = useParams();
//     const [selectedEmployeeId, setSelectedEmployeeId] = useState<number | null>();
//     const navigate = useNavigate();
//     const [formData, setFormData] = useState({
//       title: '',
//       first_name: '',
//       second_name: '',
//       email: '',
//       phone: '',
//       address: '',
//       assigned_to: null as number | null,
//       company_id: '',
//     });

//     const handleSelectEmployee = (id: string) => {
//       setFormData((prev) => ({
//         ...prev,
//         assigned_to: id ? Number(id) : null,
//       }));
//       console.log('selected id', id);
//     };

//     const handleSelectCompany = (id: string) => {
//       setFormData((prev) => ({
//         ...prev,
//         company_id: id || '',
//       }));
//       console.log('selected id', id);
//     };

//     const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
//       const { name, value } = e.target;
//       setFormData(prev => ({ ...prev, [name]: value }));
//       // console.log(formData);
//     };
  
//     const handleSubmit = async () => {
//       console.log('Customer Data:', formData);
//       if(orgId){
//         let response = await saveLead(formData?.company_id, orgId, formData.title, formData.first_name, formData.second_name, formData.email, formData.phone, "new", "INTERESTED", null, null, null, formData?.assigned_to );
//         if(response.success === true){
//           alert('New lead saved successfully.')
//           navigate(`/organization/${orgId}/leads-dashboard`)
//         }
//       } else{
//         alert('An error occured on saving. Please refresh and try again.')
//       }
//     };
  
//     return (
//       <Box maxW="800px" mx="auto" mt={4} p={8} boxShadow="xl" borderRadius="lg" bg="white">
//         <Heading mb={6} textAlign={'center'} color="#006400">Add New Lead</Heading>
//         <VStack spacing={4} align="stretch">
//           <FormControl>
//             <FormLabel>Title</FormLabel>
//             <Input name="title" value={formData.title} onChange={handleChange} placeholder="Mr., Mrs., Dr., etc." />
//           </FormControl>
//           <FormControl>
//             <FormLabel>First Name</FormLabel>
//             <Input name="first_name" value={formData.first_name} onChange={handleChange} />
//           </FormControl>
//           <FormControl>
//             <FormLabel>Second Name</FormLabel>
//             <Input name="second_name" value={formData.second_name} onChange={handleChange} />
//           </FormControl>
//           <FormControl>
//             <FormLabel>Email</FormLabel>
//             <Input type="email" name="email" value={formData.email} onChange={handleChange} />
//           </FormControl>
//           <EmployeeDropdown
//             organizationId={orgId||''}
//             onChange={handleSelectEmployee}
//           />
//           <CompanySelect onChange={handleSelectCompany} organizationId={orgId|| ''} />
//           <FormControl>
//             <FormLabel>Phone</FormLabel>
//             <PhoneInput
//               country={'zw'} // Default country
//               value={formData.phone}
//               onChange={(phone) =>
//                 setFormData({ ...formData, phone: phone.replace(/\s+/g, '') })
//               }
//               inputStyle={{
//                 width: '100%',
//                 height: '40px',
//                 borderRadius: '6px',
//                 border: '1px solid #E2E8F0',
//                 paddingLeft: '48px', // enough space for flag
//               }}
//               buttonStyle={{
//                 border: 'none',
//                 background: 'none',
//               }}
//               dropdownStyle={{
//                 maxHeight: '200px',
//                 overflowY: 'auto',
//               }}
//             />
//           </FormControl>
//           <FormControl>
//             <FormLabel>Address</FormLabel>
//             <Input name="address" value={formData.address} onChange={handleChange} />
//           </FormControl>
//           <Button bg={'#006400'} colorScheme="green" onClick={handleSubmit}>
//             Save Lead
//           </Button>
//         </VStack>
//       </Box>
//     );
//   };
  
//   export default AddNewCustomerPage;
  
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  VStack,
  Heading,
} from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { saveLead, updateLeadDetail } from "../hooks/leads";
// import { saveLead, updateLeadWithCustomer } from "../hooks/leads";
// import { saveCustomer } from "../hooks/customers";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css"; // Prebuilt styles
import { EmployeeDropdown } from "../components/EmployeeDropDown";
import CompanySelect from "../components/CompanySelect";
import { createCustomer } from "../hooks/customers";

const AddNewCustomerPage = () => {
  const { orgId } = useParams();
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<number | null>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    first_name: "",
    second_name: "",
    email: "",
    phone: "",
    address: "",
    assigned_to: null as number | null,
    company_id: "",
  });

  const handleSelectEmployee = (id: string) => {
    setFormData((prev) => ({
      ...prev,
      assigned_to: id ? Number(id) : null,
    }));
  };

  const handleSelectCompany = (id: string) => {
    setFormData((prev) => ({
      ...prev,
      company_id: id || "",
    }));
  };

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!orgId) {
      alert("Organization ID missing. Please refresh and try again.");
      return;
    }

    try {
      setLoading(true);

      // 1. Create Lead
      const leadRes = await saveLead(
        formData.company_id,
        orgId,
        formData.title,
        formData.first_name,
        formData.second_name,
        formData.email,
        formData.phone,
        "new",
        "INTERESTED",
        null,
        null,
        null,
        formData.assigned_to
      );

      console.log("Lead Response:", leadRes);

      if (!leadRes.success) {
        alert("Error creating lead");
        setLoading(false);
        return;
      }

      const leadId = leadRes.data.id;

      // 2. Create Customer
      const customerRes = await createCustomer(
        orgId,
        formData
      );

      console.log("Customer Response:", customerRes);

      if (!customerRes.success) {
        alert("Error creating customer");
        setLoading(false);
        return;
      }

      const customerId = customerRes.data.id;

      // 3. Update Lead with customerId
      let updateRes = await updateLeadDetail(orgId, leadId, 'customer', customerId);

      console.log("Update Lead Response:", updateRes);
      console.log("Linked Lead ID:", leadId, "with Customer ID:", customerId);

      alert("Customer and Lead successfully created & linked!");
      navigate(`/organization/${orgId}/customers-dashboard`);
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      maxW="800px"
      mx="auto"
      mt={4}
      p={8}
      boxShadow="xl"
      borderRadius="lg"
      bg="white"
    >
      <Heading mb={6} textAlign={"center"} color="#006400">
        Add New Customer
      </Heading>
      <VStack spacing={4} align="stretch">
        <FormControl>
          <FormLabel>Title</FormLabel>
          <Input
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="Mr., Mrs., Dr., etc."
          />
        </FormControl>
        <FormControl>
          <FormLabel>First Name</FormLabel>
          <Input
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
          />
        </FormControl>
        <FormControl>
          <FormLabel>Second Name</FormLabel>
          <Input
            name="second_name"
            value={formData.second_name}
            onChange={handleChange}
          />
        </FormControl>
        <FormControl>
          <FormLabel>Email</FormLabel>
          <Input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </FormControl>

        <EmployeeDropdown
          organizationId={orgId || ""}
          onChange={handleSelectEmployee}
        />
        <CompanySelect
          onChange={handleSelectCompany}
          organizationId={orgId || ""}
        />

        <FormControl>
          <FormLabel>Phone</FormLabel>
          <PhoneInput
            country={"zw"} // Default country
            value={formData.phone}
            onChange={(phone) =>
              setFormData({ ...formData, phone: phone.replace(/\s+/g, "") })
            }
            inputStyle={{
              width: "100%",
              height: "40px",
              borderRadius: "6px",
              border: "1px solid #E2E8F0",
              paddingLeft: "48px",
            }}
          />
        </FormControl>
        <FormControl>
          <FormLabel>Address</FormLabel>
          <Input
            name="address"
            value={formData.address}
            onChange={handleChange}
          />
        </FormControl>
        <Button
          bg={"#006400"}
          colorScheme="green"
          onClick={handleSubmit}
          isLoading={loading}
        >
          Save Customer
        </Button>
      </VStack>
    </Box>
  );
};

export default AddNewCustomerPage;
